import React from "react";

import { determineDeliveryTimeTranslationKey } from "@utils/deliveryPromise";
import { DeliveryPromiseTypes, StockLevels } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";
import { TProductAvailability } from "lib/@types/service/store/shared";

type Props = {
    productAvailability: TProductAvailability;
};

const Stock = ({ productAvailability }: Props) => {
    const { t } = useGranite();

    let className = "text-success";
    let icon = "la-check";
    const tk =
        determineDeliveryTimeTranslationKey(
            productAvailability?.deliveryPromiseType,
            productAvailability?.stockLevel,
            productAvailability?.realTimeStockAvailable,
            productAvailability?.realTimeStock,
        ) || "";

    if (
        productAvailability?.deliveryPromiseType ===
        DeliveryPromiseTypes.AvailableForS2S
    ) {
        className = "";
    } else if (!productAvailability?.realTimeStockAvailable && productAvailability?.stockLevel === StockLevels.LowStock) {
        className = "text-warning";
    } else if (
        (!productAvailability?.realTimeStockAvailable && productAvailability?.stockLevel === StockLevels.NoStock) ||
        (!productAvailability?.realTimeStockAvailable && productAvailability?.stockLevel === null) ||
        (productAvailability?.realTimeStockAvailable && productAvailability?.realTimeStock! <= 0)
    ) {
        className = "text-danger";
        icon = "la-times";
    }

    const deliveryTimeUnitTk = `product.deliveryPromise.timeUnits.${productAvailability?.deliveryTimeUnit}`;

    return (
        <span className={className}>
            <i className={`las ${icon} mr-1`} />
            {tk &&
                t(tk, productAvailability?.deliveryTime, t(deliveryTimeUnitTk), productAvailability?.realTimeStock)}
        </span>
    );
};

export default Stock;
